import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Link } from '@mui/material';

import { observer } from 'mobx-react-lite';

import Stack from '@mui/material/Stack';
import TrapFocus from '@mui/material/Unstable_TrapFocus';

import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';

import Typography from '@mui/material/Typography';

import CardCircle from '../cards/CardCircle';

const ViewHomeInsuranceDialog = observer(
  ({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element => (
    <TrapFocus open disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={open}>
        <Paper
          role="dialog"
          aria-modal="false"
          aria-label="Informationen zur Haushaltsversicherung"
          square
          elevation={6}
          sx={{
            position: 'fixed',
            top: 24,
            right: 24,
            p: 2,
            borderWidth: 0,
            borderTopWidth: 1,
            maxWidth: 550,
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              justifyContent: 'space-between',
              gap: 2,
              alignItems: 'start',
            }}
          >
            <CardCircle
              iconName="Haushaltsversicherung"
              iconSize={48}
              iconColor="primary.main"
            />
            <Box
              sx={{
                flexShrink: 1,
                alignSelf: { xs: 'flex-start', sm: 'center' },
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }} variant="h6">
                Haushaltsversicherung
              </Typography>
              <Typography variant="body1">
                Schützen Sie Ihr Zuhause in wenigen Minuten – einfach und sicher
                online abschließen.
              </Typography>

              <Button
                size="small"
                href="/haushaltsversicherung"
                component={Link}
                variant="contained"
                sx={{ mt: 1 }}
              >
                Jetzt Prämie berechnen und direkt online abschließen.
              </Button>
            </Box>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Paper>
      </Fade>
    </TrapFocus>
  ),
);

export default ViewHomeInsuranceDialog;
